<script>
import RsAttachment from "@/components/modules/rightship/RsAttachment.vue";
import {InspectorsService} from "@/services/InspectorsService";
import {InspectorsCompaniesService} from "@/services/InspectorsCompaniesService";
import ObjectMixin from "@/mixins/ObjectMixin";
import {permissionMixin} from "@/mixins/permissionMixins";
import {mapActions, mapGetters} from "vuex";
import {AlertService} from "@/services/AlertService";
import AttachmentMixin from "@/mixins/attachmentMixin";
import ComboBox from "@/components/common/ComboBox.vue";
import Swal from "sweetalert2";

export default {
  name: "RsInspection",
  mixins: [ObjectMixin, AttachmentMixin, permissionMixin],
  components: {ComboBox, RsAttachment},
  data() {
    return {
      inspectors: [],
      inspectors_list_full: [],
      companies: [],
      showAddButton: false,
      showFirstnameNew: false,
      showLastnameNew: false,
      firstLoadCompleted: false,
      isLoading : false,
      findingCount : 0,
      finalCount : 0,
      selectedRevision : null,
      filters: {},
      toEdit: false,
      toEditInspector: false,
      toEditQ: false,
      toolbar: [
        ['bold', 'italic', 'strike', 'underline'],
        [{
          'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]
        }]
      ],
      default: {
        mainReport: {
          id: parseInt(this.$route.params.id),
          inspection: {
            inspector_name: null,
            non_conformities: false,
            detained: false,
            non_conformity_count: 0,
            outline: null,
          },
        },
      },
      mainReport: {},
      questionAnswers: {},
      rankIdMaster: 1,
      rankIdCE: 2,
      crewLists: {},
      addAttachment: false,
      addAttachmentFull: false,
    }
  },
  methods: {
    ...mapActions("RevisionModule", ["fetchRevisions"]),
    ...mapActions(['updateRsInfo', 'uploadRsAttachments', 'uploadRsAttachmentsFull', 'getRsNonConformities']),

    showToast(icon, title) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon,
        title,
        showConfirmButton: false,
        timer: 2000,
      });
    },

    showAlert(icon, title, text = "", showCancel = false) {
      return Swal.fire({
        icon,
        title,
        text,
        showConfirmButton: true,
        confirmButtonColor: "#42b983",
        showCancelButton: showCancel,
        allowEscapeKey: false,
        allowOutsideClick: false,
        allowEnterKey: true,
        confirmButtonText: "OK",
      });
    },

    async fetchAllNonConformities(rsId, revisionId) {

      if (!this.firstLoadCompleted) {
        this.isLoading = true;
      }
      let page = 1;
      let allResults = [];
      let totalPages = 1;

      do {
        const response = await this.getRsNonConformities({
          rs_id: rsId,
          revision_number_id: revisionId,
          page: page
        });

        const data = response?.data ?? [];
        const lastPage = response?.last_page ?? 1;

        allResults.push(...data);
        totalPages = lastPage;
        page++;
      } while (page <= totalPages);

      this.$store.commit('SET_NON_CONFORMITIES', allResults)
      this.findingCount = allResults.length

      if (!this.firstLoadCompleted) {
        this.firstLoadCompleted = true;
        this.isLoading = false;
      }
    },
    async fetchNonConformitiesByRevision() {
      const rsId = this.rsGet("id");
      await this.fetchAllNonConformities(rsId, this.selectedRevision);
    },
    async cancelUpdate() {
      if (await AlertService.cancelAlert()) {
        this.resetFields()
        this.resetInspectorFields()
        this.fetchInspectors(this.rsGet('inspection.company_inspectors.id'));
        this.fetchInspectorsCompanies();
      }
    },
    async cancelUpdateInspector() {
      if (await AlertService.cancelAlert()) {
        this.resetInspectorFields()
        this.fetchInspectors(this.rsGet('inspection.company_inspectors.id'));
        this.fetchInspectorsCompanies();
      }
    },
    async updateRs() {
      if (await AlertService.confirmUpdateAlert("Do you want to update? ")) {
        if(!this.mainReport.inspection.company || !this.mainReport.inspection.first_name || !this.mainReport.inspection.last_name){
          this.resetInspectorFields()
        }
        const response = await this.updateRsInfo(this.mainReport);
        if (response) {
          AlertService.successAlert('Rightship updated successfully', 'UPDATE RIGHTSHIP')
          this.fetchInspectors(this.rsGet('inspection.company_inspectors.id'));
          this.fetchInspectorsCompanies();
          this.resetFields()
          this.resetInspectorFields()
        }
      }
    },
    async addInspectorData(){
      if(!this.mainReport.inspection.company){
        this.showAlert("error", "Company Field is required","Please select or type a company!");
      }
      else if (
        this.mainReport.inspection.company.trim().length < 5 ||
        this.mainReport.inspection.company.trim().length > 50
      ) {
        this.showAlert("error","Company Field is too short/long", "Company name must be between 5 and 50 characters!");
      }
      else if(!this.mainReport.inspection.last_name){
        this.showAlert("error","Lastname is required","Inspector's last name is required!");
      }
      else if (
        this.mainReport.inspection.last_name.trim().length < 2 ||
        this.mainReport.inspection.last_name.trim().length > 25
      ) {
        this.showAlert("error","Lastname is too short/long","Inspector's last name must be between 2 and 25 characters!");
      }
      else if(!this.mainReport.inspection.first_name){
        this.showAlert("error","Firstname is required","Inspector's first name is required!");
      }
      else if (
        this.mainReport.inspection.first_name.trim().length < 2 ||
        this.mainReport.inspection.first_name.trim().length > 25
      ) {
        this.showAlert("error","Firstname is too short/long","Inspector's first name must be between 2 and 25 characters!");
      }
      else if (/\d/.test(this.mainReport.inspection.first_name) || /\d/.test(this.mainReport.inspection.last_name)) {
        this.showAlert("error", "Names cannot contain numbers!", "Please make sure there are no numbers in the name!");
      }
      else if (
        !this.companies.some(
          c => c.name.trim().toLowerCase() === this.mainReport.inspection.company.trim().toLowerCase()
        )
      ) {
        this.showAlert("question", "New Company" ,"This company does not exist in the list, would you like to add it in the list of inspector companies?",true).then((result) => {
          if (result.isConfirmed) {
            const response = this.updateRsInfo(this.mainReport);
            if (response) {
              AlertService.successAlert('Rightship inspector updated successfully', 'UPDATE RIGHTSHIP')
              this.fetchInspectors(this.rsGet('inspection.company_inspectors.id'));
              this.fetchInspectorsCompanies();
              this.resetInspectorFields();
            }
          }else if (result.isDismissed) {
            AlertService.errorAlert("Company was not added", "ACTION CANCELLED");
          }
        });
      }
      else{
        if (await AlertService.confirmUpdateAlert("Do you want to update? ")) {
          const response = await this.updateRsInfo(this.mainReport);
          if (response) {
            AlertService.successAlert('Rightship inspector updated successfully', 'UPDATE RIGHTSHIP')
            this.fetchInspectors(this.rsGet('inspection.company_inspectors.id'));
            this.fetchInspectorsCompanies();
            this.resetInspectorFields();
          }
        }
      }
    },
    async checkCompanyExist() {
      let value = this.mainReport.inspection.company;

      if (!value) {
        this.showAddButton = false;
        return;
      }

      const trimmedValue = String(value).trim();

      if (!trimmedValue) {
        this.showAddButton = false;
        return;
      }

      if (!isNaN(Number(trimmedValue))) {
        this.showAddButton = false;
        return;
      }

      const exists = this.companies.some(c => {
        const name = c && c.name ? String(c.name).trim().toLowerCase() : "";
        return name === trimmedValue.toLowerCase();
      });

      this.showAddButton = !exists;
      this.mainReport.inspection.company = trimmedValue;
    },

    async checkNameExist(data) {
      const companyName = this.mainReport.inspection.company;
      if (!companyName) return;

      let first = this.mainReport.inspection.first_name
        ? this.mainReport.inspection.first_name.trim()
        : "";
      let last = this.mainReport.inspection.last_name
        ? this.mainReport.inspection.last_name.trim()
        : "";

      if (data === "firstname") {
        if (!first || !isNaN(Number(first))) {
          this.showFirstnameNew = false;
          return;
        }

        const exists = this.inspectors.some(c => {
          const cFirst = c.first_name ? c.first_name.trim().toLowerCase() : "";
          const cLast = c.last_name ? c.last_name.trim().toLowerCase() : "";

          return (
            cFirst === first.toLowerCase() &&
            (!last || cLast === last.toLowerCase())
          );
        });

        this.showFirstnameNew = !exists;
        this.mainReport.inspection.first_name = first;
      }

      if (data === "lastname") {
        if (!last || !isNaN(Number(last))) {
          this.showLastnameNew = false;
          return;
        }

        const exists = this.inspectors.some(c => {
          const cFirst = c.first_name ? c.first_name.trim().toLowerCase() : "";
          const cLast = c.last_name ? c.last_name.trim().toLowerCase() : "";

          return (
            cLast === last.toLowerCase() &&
            (!first || cFirst === first.toLowerCase())
          );
        });

        this.showLastnameNew = !exists;
        this.mainReport.inspection.last_name = last;
      }
    },

    editMainReport() {
      this.toEdit = true;
      this.mainReport = {
        id: this.rsGet('id'),
        inspection: {
          inspector_name: this.rsGet('inspection.inspector_name'),
          first_name: this.rsGet('inspection.company_inspector.first_name'),
          last_name: this.rsGet('inspection.company_inspector.last_name'),
          company: this.rsGet('inspection.company_inspectors.name'),
          non_conformities: !!this.rsGet('inspection.non_conformities', false),
          detained: !!this.rsGet('inspection.detained'),
          non_conformity_count: this.rsGet('non_conformity_count'),
          outline: this.rsGet('inspection.outline'),
        }
      }
      const match = this.companies.find(
        c => c.name === this.mainReport.inspection.company
      );
      if (match) {
        this.fetchInspectors(match.id);
      }
    },

    editInspectorData(){
      this.toEditInspector = true;
      this.editMainReport();
    },
    resetFields() {
      this.toEdit = false;
      this.mainReport = this.default.mainReport;
      this.fetchInspectors(this.rsGet('inspection.company_inspectors.id'));
      this.fetchInspectorsCompanies();
      this.showAddButton = false;
      this.showFirstnameNew = false;
      this.showLastnameNew = false;
    },

    resetInspectorFields(){
      this.toEditInspector = false;
      this.mainReport = this.default.mainReport;
      this.fetchInspectors(this.rsGet('inspection.company_inspectors.id'));
      this.fetchInspectorsCompanies();
      this.showAddButton = false;
      this.showFirstnameNew = false;
      this.showLastnameNew = false;
    },

    async addAttachmentToInspection() {
      let formData = new FormData();

      if (this.$refs.inspectionAttachments.files.length) {
        Array.prototype.forEach.call(this.$refs.inspectionAttachments.files, file => {
          formData.append('attachments[]', file)
        })
      }
      formData.append('id', this.rsGet('id'))
      formData.append('type[id]', this.rsGet('inspection.id'))
      formData.append('type[type_id]', 1)
      const response = await this.uploadRsAttachments(formData);
      if (response) {
        AlertService.successAlert('Attachment added successfully', 'Add Inspection Attachments')
        this.addAttachment = false;
        await this.getRsAttachment(1, this.rsReport, 'inspection.id')
      }
    },

    async addAttachmentToInspectionFull() {
      let formData = new FormData();

      if (this.$refs.inspectionAttachmentsFull.files.length) {
        Array.prototype.forEach.call(this.$refs.inspectionAttachmentsFull.files, file => {
          formData.append('attachments[]', file)
        })
      }
      formData.append('id', this.rsGet('id'))
      formData.append('type[id]', this.rsGet('inspection.id'))
      formData.append('type[type_id]', 6)
      const response = await this.uploadRsAttachmentsFull(formData);
      if (response) {
        AlertService.successAlert('Attachment added successfully', 'Add Inspection Attachments')
        this.addAttachmentFull = false;
        this.$refs.inspectionAttachmentsFull.value = null;
        await this.getRsAttachmentFull(6, this.rsReport, 'inspection.id')
      }
    },

    async cancelUpload() {
      if (await AlertService.cancelAlert()) {
        this.$refs.inspectionAttachments.value = null;
        this.addAttachment = false;
      }
    },

    async cancelUploadFull() {
      if (await AlertService.cancelAlert()) {
        this.$refs.inspectionAttachmentsFull.value = null;
        this.addAttachment = false;
      }
    },

    async deleteInspectionAttachments(attachment) {
      const file = attachment.attachment
      const type = attachment.type
      const response = await this.deleteFileRs(file, type)
      if (response) {
        AlertService.successAlert('Rightship Inspection Attachment deleted successfully', 'DELETE INSPECTION ATTACHMENT')
        await this.getRsAttachment(type, this.rsReport, 'inspection.id')
      }
    },

    getAnswer(questionAnswer, default_value = null) {
      let value = null;

      switch (questionAnswer?.rs_question?.rs_question_type?.description) {
        case 'text':
          value = questionAnswer.answer;
          break;
        case 'options':
          value = questionAnswer.answer_value ? parseInt(questionAnswer.answer_value) : 0;
          let option = questionAnswer.rs_question.rs_dropdown_options.filter(option => option.id == value);
          option = option.length ? option[0] : {};
          value = Object.keys(option).length ? option.value : null;
          break;
        case 'boolean':
          value = Boolean(questionAnswer.answer) ? 'Yes' : 'No';
          break;
        case 'boolean-text':
          value = Boolean(questionAnswer.answer_value) ? ('Yes: ' + questionAnswer.answer) : 'No';
          break;

        case 'integer':
          // @TODO: create new question type 'float'...
          value = `${!isNaN(questionAnswer.answer) && questionAnswer.answer ? parseFloat(questionAnswer.answer) : '0'}
                   ${questionAnswer.rs_question.rs_question_type.id == 5 ? "hrs" : ''}`
          break;
      }

      if (value != null) {
        value = String(value).toUpperCase();
      }

      return value ?? default_value;
    },
    getQuestionnaire() {
      this.questionAnswers = JSON.parse(JSON.stringify(this.rsGet('question_answers', {})));
    },
    editQuestionnaire() {
      this.toEditQ = true;
      this.getQuestionnaire();
    },
    resetQuestionnaireFields() {
      this.toEditQ = false;
      this.getQuestionnaire();
    },
    async submitQuestionnaire() {
      if (await AlertService.confirmUpdateAlert("Do you want to update?")) {
        const params = {
          __return_response: true,
          id: this.rsGet('id'),
          question_answers: this.questionAnswers,
        };

        const response = await this.updateRsInfo(params);

        if (response.status === 200) {
          AlertService.successAlert('Questionnaire has been updated successfully', 'UPDATE RIGHTSHIP');
          this.resetQuestionnaireFields();
        }
      }
    },
    updateQuestionAnswer(index, type = 'text') {
      let answer = this.questionAnswers[index].answer;
      let answer_value = this.questionAnswers[index].answer_value;

      switch (type) {
        case 'boolean':
        case 'options':
          this.questionAnswers[index].answer = answer_value ? answer_value : null;
          break;
        case 'boolean-text':
          this.questionAnswers[index].answer = answer_value ? answer : null;
          break;
      }
    },
    async cancelEditQuestionAnswer() {
      if (await AlertService.cancelAlert()) {
        this.resetQuestionnaireFields();
      }
    },
    async fetchInspectors(id){
      const response = await InspectorsService.showCompanyInspectors(id);
      this.inspectors = response.data;
    },
    async fetchInspectorsFull(){
      const response = await InspectorsService.getAll();
      this.inspectors_list_full = response.data;
    },
    async fetchInspectorsCompanies(){
      const response = await InspectorsCompaniesService.getAll();
      this.companies = response.data;
    },

    async onCompanySelected(selected) {
      this.mainReport.inspection.first_name = null;
      this.mainReport.inspection.last_name = null;
      const match = this.companies.find(c => c.name === selected);
      if (match) {
        this.fetchInspectors(match.id);
      }
    },

  },
  async created() {
    await this.fetchRevisions();
    if (this.revisions.length > 0) {
      this.selectedRevision = this.revisions[0].id;
      await this.fetchNonConformitiesByRevision();
    }
    await this.getQuestionnaire();
    await this.fetchInspectorsCompanies();
    await this.fetchInspectorsFull();
  },

  watch: {
    selectedRevision() {
      this.fetchNonConformitiesByRevision();
    }
  },
  computed: {
    ...mapGetters("RevisionModule", ["revisions"]),
    ...mapGetters([
      'rsReport',
      'rsAttachments',
      'rsAttachmentsFull',
      'rsNonConformities'
    ]),

    filteredLastNames() {
      if (this.mainReport.inspection.first_name) {
        return this.inspectors.filter(
          ins => ins.first_name === this.mainReport.inspection.first_name
        );
      }
      return this.inspectors;
    },
    filteredFirstNames() {
      if (this.mainReport.inspection.last_name) {
        return this.inspectors.filter(
          ins => ins.last_name === this.mainReport.inspection.last_name
        );
      }
      return this.inspectors;
    }
  },
}
</script>
<template>
  <div>
    <div class="card p-3 shadow-sm">
      <form @submit.prevent="">
        <div class="row justify-content-between">
          <div class="col-auto">
            <h5 class="e-text-red">
              Inspection
            </h5>
          </div>
          <div class="col-auto">
            <template v-if="toEdit">
              <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancelUpdate" v-if="toEdit">Cancel</button>
              <button class="e-btn e-btn-blue ml-2" type="button" @click="updateRs">Save</button>
            </template>
            <template v-else>
              <button class="e-btn e-btn-green ml-2 px-3" type="button" @click="editMainReport"
                      v-if="isAllowed('rightship.main.inspection.details.edit') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
              >Edit Inspection Details
              </button>
            </template>
          </div>
        </div>
        <table class="w-100">
          <tr>
            <td style="width: 25%">Inspector's Company</td>
            <td>
              <div v-if="toEditInspector">
                <ComboBox
                  v-model="mainReport.inspection.company"
                  :options="companies"
                  displayKey="name"
                  valueKey="id"
                  placeholder="-- Select or type a company --"
                  @blur="checkCompanyExist"
                  @input="onCompanySelected"
                />
                <small class="text-danger font-weight-bold ml-1" style="font-style: italic" v-if="!mainReport.inspection.company">* Required</small>
                <small class="e-text-green font-weight-bold ml-1" style="font-style: italic" v-if="showAddButton">* New Company</small>
              </div>
              <div v-else>
                <span>{{ rsGet('inspection.company_inspectors.name') | toUpper }}</span>
                <template v-if="isAllowed('rightship.main.inspection.details.edit') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')">
                  <a class="ml-1 text-primary" style="font-style: italic; cursor: pointer" @click="editInspectorData" v-if="rsGet('inspection.company_inspectors.name') || rsGet('inspection.company_inspector.full_name')">(edit details)</a>
                  <a class="ml-1 text-primary" style="font-style: italic; cursor: pointer" @click="editInspectorData" v-else>(add details)</a>
                </template>

              </div>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">Name of Inspector</td>
            <td>
              <div class="row mt-3 mb-2" v-if="toEditInspector">
                <div class="col-auto">
                  <label>Last Name</label>
                  <ComboBox
                    v-model="mainReport.inspection.last_name"
                    :options="filteredLastNames"
                    displayKey="last_name"
                    valueKey="last_name"
                    :disabled="!mainReport.inspection.company"
                    placeholder="-- Select or type a last name --"
                    @blur="checkNameExist('lastname')"
                  />
                  <small class="text-danger font-weight-bold ml-1" style="font-style: italic" v-if="!mainReport.inspection.last_name">* Required</small>
                  <small class="e-text-green font-weight-bold ml-1" style="font-style: italic" v-if="showLastnameNew && mainReport.inspection.last_name">* New Inspector</small>
                </div>
                <div class="col-auto">
                  <label>First Name</label>
                  <ComboBox
                    v-model="mainReport.inspection.first_name"
                    :options="filteredFirstNames"
                    displayKey="first_name"
                    valueKey="first_name"
                    :disabled="!mainReport.inspection.company"
                    placeholder="-- Select or type a first name --"
                    @blur="checkNameExist('firstname')"
                  />
                  <small class="text-danger font-weight-bold ml-1" style="font-style: italic" v-if="!mainReport.inspection.first_name">* Required</small>
                  <small class="e-text-green font-weight-bold ml-1" style="font-style: italic" v-if="showFirstnameNew && mainReport.inspection.first_name">* New Inspector</small>
                </div>
                <div class="col-auto" v-if="showAddButton">
                  <label class="text-white">Action</label><br>
                  <button type="button" class="e-btn e-btn-green" @click="addInspectorData">Add & Save New Data</button>
                  <button type="button" class="e-btn e-btn-red ml-1" @click="cancelUpdateInspector">Cancel</button>
                </div>
                <div class="col-auto" v-else>
                  <label class="text-white">Action</label><br>
                  <button type="button" class="e-btn e-btn-blue" @click="addInspectorData">Save Inspector Data</button>
                  <button type="button" class="e-btn e-btn-red ml-1" @click="cancelUpdateInspector">Cancel</button>
                </div>
              </div>
              <span v-else>{{ rsGet('inspection.company_inspector.full_name') | toUpper }}</span>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">
              <div class="d-flex align-items-center">
                <span class="mr-2">Number of Findings</span>
                <select
                  v-if="revisions && revisions.length"
                  class="form-control form-control-sm"
                  v-model="selectedRevision"
                  style="width: auto; padding: 0.1rem 0.3rem; font-size: 0.75rem; height: auto; font-weight: bold;"
                >
                  <option
                    v-for="revision in revisions"
                    :key="revision.id"
                    :value="revision.id"
                    :disabled="revision.id === selectedRevision"
                  >
                    v{{ revision.revision_number }}
                  </option>
                </select>
              </div>
            </td>
            <td>
              <span class="d-flex align-items-center">
                <strong v-if="!firstLoadCompleted">
                  Loading Number of Findings...  <div v-if="!firstLoadCompleted"
                  class="spinner-border spinner-border-sm ms-2 text-primary"
                  role="status"
                  aria-hidden="true"></div>
                </strong>
                <span v-else>{{ findingCount }}</span>
              </span>
            </td>
          </tr>

          <!--              <input type="number" :step="0" :min="0" v-if="toEdit" v-model="mainReport.inspection.non_conformity_count"-->
          <!--                     class="form-control-sm form-control" name="rs_non_conformity_count" id="rs_non_conformity_count">-->
          <!--              <span v-else>{{ rsGet('non_conformity_count', 0) }}</span>-->
          <tr>
            <td style="width: 25%" class="align-top">Inspection Outline</td>
            <td>
              <vue-editor v-if="toEdit" v-model="mainReport.inspection.outline" :editor-toolbar="toolbar"></vue-editor>
              <div v-else id="textArea" class="pre-wrap-txt textarea-display-card my-2" v-html="rsGet('inspection.outline')"/>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">Completion of the list of non-conformities and inspection report</td>
            <td>
              <template v-if="toEdit">
                <template v-if="!addAttachment">
                  <button class="e-btn e-btn-green mr-3" @click="addAttachment=!addAttachment"
                          v-if="isAllowed('rightship.main.inspection.details.attachments.edit') || user.id === rsReport.created_by_id || isElite()">
                    Add Attachment
                  </button>
                </template>
                <div v-else>
                  <input type="file" class="w-75" ref="inspectionAttachments" multiple @change="addAttachmentToInspection">
                  <button class="e-btn e-btn-outlined-red" @click="cancelUpload">Cancel</button>
                </div>
              </template>
              <template v-else>
                <button class="e-btn e-btn-blue" @click="downloadAllRs(1,rsReport,'inspection.id')"
                        v-if="rsAttachments.length && isOwnVessel('rsReport') && (isAllowed('rightship.main.inspection.details.attachments.download-all') || user.id === rsReport.created_by_id || isElite())">
                  Download All
                </button>
              </template>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <rs-attachment v-if="rsAttachments.length" :attachments="rsAttachments"
                             style="min-height: 15vh;"
                             :type="1"
                             view-permission="rightship.main.inspection.details.attachments.view"
                             download-permssion="rightship.main.inspection.details.attachments.view"
                             delete-permission="rightship.main.inspection.details.attachments.edit"
                             @deleteEmitter="deleteInspectionAttachments"
              >
              </rs-attachment>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">Full Inspection Report</td>
            <td>
              <template v-if="toEdit">
                <template v-if="!addAttachmentFull">
                  <button class="e-btn e-btn-green mr-3" @click="addAttachmentFull=!addAttachmentFull"
                          v-if="rsAttachmentsFull.length <=1 && (isAllowed('rightship.main.inspection.details.attachments.edit') || user.id === rsReport.created_by_id || isElite())">
                    Add Attachment
                  </button>
                </template>
                <div v-else>
                  <input type="file" class="w-75" ref="inspectionAttachmentsFull" multiple @change="addAttachmentToInspectionFull">
                  <button class="e-btn e-btn-outlined-red" @click="cancelUploadFull">Cancel</button>
                </div>
              </template>
              <template v-else>
                <button class="e-btn e-btn-blue" @click="downloadAllRs(6,rsReport,'inspection.id')"
                        v-if="rsAttachmentsFull.length && isOwnVessel('rsReport') && (isAllowed('rightship.main.inspection.details.attachments.download-all') || user.id === rsReport.created_by_id || isElite())">
                  Download All
                </button>
              </template>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <rs-attachment v-if="rsAttachmentsFull.length" :attachments="rsAttachmentsFull"
                             style="min-height: 15vh;"
                             :type="6"
                             view-permission="rightship.main.inspection.details.attachments.view"
                             download-permssion="rightship.main.inspection.details.attachments.view"
                             delete-permission="rightship.main.inspection.details.attachments.edit"
                             @deleteEmitter="deleteInspectionAttachments"
              >
              </rs-attachment>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <hr/>
            </td>
          </tr>
        </table>
      </form>
      <form @submit.prevent="submitQuestionnaire">
        <div class="row justify-content-between">
          <div class="col-auto">
            <h5 class="e-text-red">
              Questionnaire
            </h5>
          </div>
          <div class="col-auto">
            <template v-if="!toEditQ">
              <button class="e-btn e-btn-green ml-2" type="button" v-if="isAllowed('rightship.main.inspection.questionaires.edit') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')" @click="editQuestionnaire">Edit Questionnaire</button>
            </template>
             <template v-else>
              <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancelEditQuestionAnswer">Cancel</button>
              <button class="e-btn e-btn-blue ml-2" type="submit">Save</button>
            </template>
          </div>
        </div>
        <table class="w-100">
          <template v-if="Object.keys(questionAnswers).length">
            <tr v-for="(questionAnswer, index) in questionAnswers">
              <td style="width: 50%; vertical-align: top;">{{ questionAnswer.rs_question.description }}</td>
              <td>
                <template v-if="toEditQ">
                  <template v-if="questionAnswer.rs_question.rs_question_type.description === 'text'">
                    <input class="form-control-sm form-control mb-1" type="text" v-model="questionAnswers[index].answer">
                  </template>
                  <template v-if="questionAnswer.rs_question.rs_question_type.description === 'integer'">
                    <div class="row ml-0 align-items-center">
                      <input class="form-control-sm form-control mb-1 col-3" type="text" v-model="questionAnswers[index].answer">
                      <span class="font-weight-bold pl-2">{{ questionAnswer.rs_question.rs_question_type.id == 5 ? 'Hrs' : '' }}</span>
                    </div>
                  </template>
                  <template v-if="questionAnswer.rs_question.rs_question_type.description === 'boolean'">
                    <select class="form-control form-control-sm mb-1" v-model="questionAnswers[index].answer_value" style="width: 130px;"
                            @change="updateQuestionAnswer(index, questionAnswer.rs_question.rs_question_type.description)">
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </template>
                  <template v-if="questionAnswer.rs_question.rs_question_type.description === 'boolean-text'">
                    <div class="form-row mb-1 p-1">
                      <select class="form-control form-control-sm col-3" v-model="questionAnswers[index].answer_value" style="width: 130px;"
                              @change="updateQuestionAnswer(index, questionAnswer.rs_question.rs_question_type.description)">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                      </select>

                      <template v-if="!!questionAnswers[index].answer_value">
                        <input class="form-control form-control-sm col-9" type="text" v-model="questionAnswers[index].answer">
                      </template>
                    </div>
                  </template>
                  <template v-if="questionAnswer.rs_question.rs_question_type.description === 'options'">
                    <div class="form-row mb-1 p-1">
                      <select class="form-control form-control-sm col-3" v-model="questionAnswers[index].answer_value" style="width: 130px;"
                              @change="updateQuestionAnswer(index, questionAnswer.rs_question.rs_question_type.description)">
                        <option value="0" :disabled="questionAnswers[index].answer_value == 0">Select One</option>
                        <template v-for="option in questionAnswer.rs_question.rs_dropdown_options">
                          <option :value="option.id" :disabled="option.id == questionAnswers[index].answer_value">{{ option.value }}</option>
                        </template>
                      </select>
                    </div>
                  </template>
                </template>
                <template v-else>
                  {{ getAnswer(questionAnswer, 'N/A') }}
                </template>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="2" class="text-center">
              No Questionnaire Found.
            </td>
          </tr>
        </table>
      </form>
    </div>
  </div>
</template>

<style scoped>
table td {
  padding: 2px !important;
}
</style>
